import { defineMessages } from 'react-intl';

const messages = defineMessages({
  NoGutter: {
    id: 'nogutter',
    defaultMessage: 'no gutter',
  },
});

export const noGutterSchemaEnhancer = ({ schema, formData, intl }) => {
  schema.properties.nogutter = {
    type: 'boolean',
    title: intl.formatMessage(messages.NoGutter),
    default: false,
  };
  schema.fieldsets[0].fields = [...schema.fieldsets[0].fields, 'nogutter'];

  return schema;
};
